import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

// 01.引入系统相关组件
// 01.01.Router 路由管理
import router from './router'
// 01.02.Store 状态管理
import store from "./store"
// 01.03.Axios 异步交互
import Api from "./axios"
// 01.04.Echarts 图表
import * as eCharts from 'echarts'
import '../public/js/echarts/theme/index'
// 01.05.Element 架构
import Element from 'element-ui'
import "element-ui/lib/theme-chalk/index.css"
// 01.06.UI 架构
import "../public/css/element.css"
import "../public/css/default.css"
// 01.07.Icon 图标
import "../public/css/ionicons/css/ionicons.css"
// 01.08.Permissions 权限认证
import Permissions from "./permissions/index";
// 01.09.Quill 富文本编译器
import VueQuillEditor from 'vue-quill-editor'
import * as Quill from 'quill'
import {ImageDrop} from 'quill-image-drop-module'
import ImageResize from 'quill-image-resize-module'

Quill.register('modules/imageDrop', ImageDrop)
Quill.register('modules/imageResize', ImageResize)
import "../public/css/quill.css"
// 01.10.DefaultPassiveEvents 鼠标滚动检测
import 'default-passive-events'
import VTooltip from 'v-tooltip'

Vue.use(VTooltip)
Vue.use(Element)
Vue.use(VueQuillEditor)
Vue.use(Permissions)

// 02.全局变量
// 02.01.定义系统Title
Vue.prototype.$title = '模板后台系统'
// 02.02.接口URL - 正式
Vue.prototype.$api_url = 'http://sxgsxx.com:9000'
// 02.03.接口URL - 开发
// Vue.prototype.$api_url = 'http://localhost:8000'
// 02.04.Axios - 通用封装类
Vue.prototype.$api = Api
// 02.05.变量 - 全局变量类
Vue.prototype.$store = store
// 02.06.富文本 - 配置类
const uploadConfig = {
    action: 'http://sxgsxx.com:9000/api/upload/file/',  // 必填参数 图片上传地址
    //action: 'http://localhost:8000/api/upload/file/',
    methods: 'POST',  // 必填参数 图片上传方式
    token: localStorage.getItem('Token'),  // 可选参数 如果需要token验证，假设你的token有存放在sessionStorage
    name: 'file',  // 必填参数 文件的参数名
    size: 102400,  // 可选参数   图片大小，单位为Kb, 1M = 1024Kb
    accept: '.png,.gif,.jpeg,.jpg,.bmp,.zip,.rar,.xls,.xlsx,.doc,.docx,.pdf'  // 可选 可上传的图片格式
};
// 源码中是import直接倒入，这里要用Quill.import引入
const Link = Quill.import("formats/link");
// 正式环境清除所有console.log
if (process.env.NODE_ENV === 'production') {if (window) {window.console.log = function () {}}
}
// 自定义a链接
class FileBlot extends Link {
    // 继承Link Blot
    static create(value) {
        let node = undefined;
        if (value && !value.href) {
            // 适应原本的Link Blot
            node = super.create(value)
        } else {
            // 自定义Link Blot
            node = super.create(value.href)
            node.href = value.href
            node.innerText = value.innerText
            // node.setAttribute('download', value.innerText);  // 左键点击即下载
        }
        return node;
    }
}

FileBlot.blotName = "link" // 这里不用改，如果需要也可以保留原来的，这里用个新的blot
FileBlot.tagName = "A"
Quill.register(FileBlot) // 注册link

const handlers = {
    image: function image() {
        var self = this;
        var fileInput = this.container.querySelector('input.ql-image[type=file]');
        if (fileInput === null) {
            fileInput = document.createElement('input');
            fileInput.setAttribute('type', 'file');
            // 设置图片参数名
            if (uploadConfig.name) {
                fileInput.setAttribute('name', uploadConfig.name);
            }
            // 可设置上传图片的格式
            fileInput.setAttribute('accept', uploadConfig.accept);
            fileInput.classList.add('ql-image');

            // 监听选择文件
            fileInput.addEventListener('change', function () {
                // 创建formData
                var formData = new FormData();
                formData.append(uploadConfig.name, fileInput.files[0]);
                formData.append('object', 'product');
                // 图片上传
                var xhr = new XMLHttpRequest();
                xhr.open(uploadConfig.methods, uploadConfig.action, true);
                // 如果需要token且存在token
                if (uploadConfig.token) {
                    xhr.setRequestHeader('TOKEN', uploadConfig.token)
                }
                // 上传数据成功，会触发
                xhr.onload = function () {
                    if (xhr.status === 200) {
                        var res = JSON.parse(xhr.responseText);
                        let length = self.quill.getSelection(true).index;
                        // 这里很重要，你图片上传成功后，img的src需要在这里添加，res.path就是你服务器返回的图片链接。
                        if (res.data.split(".")[1] === "png" || res.data.split(".")[1] === "gif" || res.data.split(".")[1] === "jpeg" || res.data.split(".")[1] === "jpg" || res.data.split(".")[1] === "bmp") {
                            self.quill.insertEmbed(length, 'image', 'http://sxgsxx.com:9000/static/upload' + res.data);
                            // self.quill.insertEmbed(length, 'image', 'http://localhost:8000/static/upload' + res.data);
                            // }
                            if (res.data.split(".")[1] === "zip" || res.data.split(".")[1] === "rar" || res.data.split(".")[1] === "xls" || res.data.split(".")[1] === "xlsx" || res.data.split(".")[1] === "doc" || res.data.split(".")[1] === "docx" || res.data.split(".")[1] === "pdf") {
                                const linkA = 'http://sxgsxx.com:9000/static/upload' + res.data
                                // const linkA = 'http://localhost:8000/static/upload' + res.data
                                const linkText = res.data.split("/")[2]
                                self.quill.insertEmbed(length, 'link', {
                                    href: linkA,
                                    innerText: linkText
                                });
                            }
                            self.quill.setSelection(length + 1)
                        }
                        fileInput.value = ''
                    }

                };
                // 开始上传数据
                xhr.upload.onloadstart = function () {
                    fileInput.value = ''
                };
                // 当发生网络异常的时候会触发，如果上传数据的过程还未结束
                xhr.upload.onerror = function () {
                };
                // 上传数据完成（成功或者失败）时会触发
                xhr.upload.onloadend = function () {
                    // console.log('上传结束')
                };
                xhr.send(formData)
            });
            this.container.appendChild(fileInput);
        }
        fileInput.click();
    }
};
Vue.prototype.$editor = {
    // 工具栏自定义
    modules: {
        imageDrop: true,      // 图片拖拽
        imageResize: {          // 放大缩小
            displaySize: true
        },
        toolbar: {
            container: [
                {
                    "header": [false, 1, 2, 3, 4, 5, 6]
                },
                "bold",
                "italic",
                "underline",
                "strike",
                {
                    "color": ["#ffffff", "#0291ff", "#44d1fd", "#7ed221", "#ffa715", "#ff5400"]
                },
                {
                    "background": ["#0291ff", "#44d1fd", "#7ed221", "#ffa715", "#ff5400"]
                },
                {
                    "align": []
                },
                "image",
                "link"
            ],
            handlers: handlers
        }
    },
    placeholder: "请输入相关内容"
}
// 02.07.图表 - 配置类
Vue.prototype.$echarts = eCharts


new Vue({
    el: '#app',
    router,
    store,
    components: {App},
    render: h => h(App)
})
